"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESUME_OPTIMIZATIONS = void 0;
var client_1 = require("@apollo/client");
exports.RESUME_OPTIMIZATIONS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation ResumeOptimizations($input: OptimizationsInput!) {\n    resumeOptimizationsInCompanyStores(input: $input) {\n      success\n      storeIds\n    }\n  }\n"], ["\n  mutation ResumeOptimizations($input: OptimizationsInput!) {\n    resumeOptimizationsInCompanyStores(input: $input) {\n      success\n      storeIds\n    }\n  }\n"])));
var templateObject_1;
